// extracted by mini-css-extract-plugin
module.exports = {"addressHeader":"AddressData_addressHeader__1IdZH","listItem":"AddressData_listItem__2gMOf"};